import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.link.url
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["desktop-link", `text--${_ctx.link.color} ${_ctx.isActive ? 'text--shadow text--bold' : ''}`]),
        style: _normalizeStyle(`${!_ctx.isActive ? 'font-weight: ' + _ctx.getFontWeight : ''}`)
      }, _toDisplayString(_ctx.link.text), 7)
    ]),
    _: 1
  }, 8, ["to"]))
}